import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["I18nProvider"] */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/src/i18n/client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HtmlLang"] */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/src/i18n/html-lang.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageSwitcher"] */ "/opt/storelancer/releases/20261014193255-3b00702af6c9/src/i18n/language-switcher.tsx");
